var map = {
	"./abyrg-framtid.json": 795,
	"./atvinnumal.json": 796,
	"./byggdarmal.json": 797,
	"./candidates2.json": 798,
	"./categories.json": 687,
	"./efnahagsmal.json": 799,
	"./evropumal.json": 800,
	"./flokkur-folksins.json": 801,
	"./framsoknarflokkurinn.json": 802,
	"./heilbrigdismal.json": 803,
	"./husnaedismal.json": 804,
	"./jafnrettismal.json": 805,
	"./loftslagsmal.json": 806,
	"./lydraedisflokkurinn.json": 807,
	"./menntamal.json": 808,
	"./midflokkurinn.json": 809,
	"./orkumal.json": 810,
	"./parties.json": 662,
	"./piratar.json": 811,
	"./replies-candidates2.json": 679,
	"./replies-parties.json": 714,
	"./samfylkingin.json": 812,
	"./samgongumal.json": 813,
	"./sjalfstaedisflokkurinn.json": 814,
	"./sjavarutvegsmal.json": 815,
	"./skattamal.json": 816,
	"./sosialistaflokkurinn.json": 817,
	"./stjornarskrarmal.json": 818,
	"./umhverfismal.json": 819,
	"./utlendingamal.json": 820,
	"./velferdarmal.json": 821,
	"./vidreisn.json": 822,
	"./vinstri-graen.json": 823
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;


//////////////////
// WEBPACK FOOTER
// ./data/build ^\.\/.*\.json$
// module id = 794
// module chunks = 5 6